module.exports = __webpack_public_path__ + "static/media/down-icon.c0552237.svg";